import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/card-component/GraduatesCard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/component/Projects.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
